import styled from 'styled-components'
import { CustomModalStyled } from '@edulastic/common'
import { IconCopyContent } from '@edulastic/icons'
import { themeColor, red, black } from '@edulastic/colors'

export const MfaCodeModalStyled = styled(CustomModalStyled)`
  .ant-modal-content {
    .ant-modal-close {
      top: 32px;
      right: 45px;
    }
    .ant-modal-close-x {
      width: 14px;
      height: 14px;
      line-height: 14px;
    }
    .ant-modal-header {
      border: none;
      border-bottom: 1px solid #e8e8e8;
      padding-bottom: 32px;
      .ant-modal-title {
        color: ${black} !important;
        font-size: 18px !important;
        font-weight: 400 !important;
      }
    }
    .ant-modal-body {
      padding-top: 16px;
      padding-bottom: 0px;
    }
  }
`

export const ModalBody = styled.div`
  text-align: center;
  padding: 8px 0 4px;
`

export const CodeDisplayRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0px;
  margin: 24px 0 27px;
`

export const CodeDisplay = styled.div`
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 12px;
  color: ${black} !important;
  font-weight: 700 !important;
  line-height: 1.2;
`

export const CopyCodeButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 0;

  &:hover {
    opacity: 0.8;
  }

  &:focus-visible {
    outline: 2px solid ${themeColor};
    outline-offset: 2px;
    border-radius: 4px;
  }
`

export const StyledIconCopyContent = styled(IconCopyContent)`
  width: 24px;
  height: 24px;
  cursor: pointer;
`

export const Description = styled.p`
  color: ${({ $isError }) => ($isError ? red : black)} !important;
  font-size: 14px;
  line-height: 20px;
  margin: 0 0 8px;
  text-align: left;
  font-weight: 400 !important;
`

export const ExpiryNote = styled.p`
  color: #707070 !important;
  font-size: 14px;
  font-weight: 400 !important;
  text-align: left;
  line-height: 20px;
  margin: 0 !important;
`

export const FooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
`

export const OKButton = styled.button`
  min-width: 53px;
  height: 36px;
  border-radius: 6px;
  border: none;
  background: ${themeColor};
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`
